import {WindowType} from '@/hosted_fields/common/enums';
import Client from '@/hosted_fields/common/connection/client';
import Receiver from '@/hosted_fields/common/connection/receiver';
import MasterActions from '@/hosted_fields/master/master-actions';
import '@/helpers/polyfills';

const client = new Client(WindowType.Master, true);
new Receiver(WindowType.Master);
MasterActions(client);
